import { AfterContentInit, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Intervention } from 'src/app/domain/intervention';
import { InterventionService } from 'src/app/services/intervention.service';
import { PreventDoubleClickDirective } from 'src/app/tools/directive/prevent-double-click.directive';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { BaseComponent } from '../base/base.component';
import { DocumentService } from 'src/app/services/document.service';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-file',
    standalone: true,
    imports: [MatIconModule, MatButtonModule, PreventDoubleClickDirective, MatDividerModule],
    templateUrl: './file.component.html',
    styleUrl: './file.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FileComponent extends BaseComponent implements OnInit, AfterContentInit {

    EDocumentType = EDocumentType;
    Model?: Intervention;
    private intCode: string = '';

    constructor(private route: ActivatedRoute,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private interventionService: InterventionService,
        private documentService: DocumentService

    ) {
        super();
    }

    ngAfterContentInit(): void {
        this.intCode = this.route.snapshot.params['interventionCode'];
        this.getInterventionWithQualifSalleOnlineByCode(this.intCode);
    }

    ngOnInit(): void {

    }

    getInterventionWithQualifSalleOnlineByCode(code: string) {
        this.interventionService.getInterventionWithQualifSalleOnlyByCode(code).subscribe(x => {
            this.Model = x;
        })
    }

    getInterventionWithQualifSalleOnlineByFilter() {
        this.interventionService.getInterventionWithQualifSalleOnlyByFilter().subscribe(x => {
            this.Model = x.find(x => x.Code === this.intCode);
        })
    }

    openDocumentDialog(code: string, type: EDocumentType) {
        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: {
                type: type,
                code: code
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: string) => {
            if (result) { // result = file name

                NotificationManager.handleSuccess('Fichier(s) correctement ajouté(s)', this.snackBar)
            }
        });
    }

    getMesureTerrainForQualifSalleDocument(prelevementQualifSalleCode: string) {
        this.documentService.getMesureTerrainForQualifSalle(prelevementQualifSalleCode).subscribe(x => {
            this.promptFile(x);
        });
    }

    getPlanForQualifSalleDocument(prelevementQualifSalleCode: string) {
        this.documentService.getPlanForQualifSalle(prelevementQualifSalleCode).subscribe(x => {
            this.promptFile(x);
        });
    }

    getReportDocument(prelevementQualifSalleCode: string) {
        this.documentService.getReport(prelevementQualifSalleCode).subscribe(x => {
            this.promptFile(x);
        });
    }

    getReportRawVersionDocument(prelevementQualifSalleCode: string) {
        this.documentService.getReportRawVersion(prelevementQualifSalleCode).subscribe(x => {
            this.promptFile(x);
        });
    }

    generateReportDocument(prelevementQualifSalleCode: string) {
        this.documentService.generateReport(prelevementQualifSalleCode).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Rapport généré !', this.snackBar);
            }
        })
    }
}
